import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import { useAuth } from 'context/AuthContext'
import { useTenantContext } from 'context/TenantContext'
import Cookies from 'js-cookie'
import { useRouter } from 'next/router'
import { MouseEvent, ReactElement, useState } from 'react'
import { classNames } from 'utils/dom-helpers'
import { getTranslation } from 'utils/language-helper'

type TopBarItem = {
    translation_key?: string
    text?: string
    icon?: string
    route?: string
    selected?: boolean
    onClick?(): void
}
interface Props {
    children?: ReactElement
}

function BookingPageTopBar({ children }: Props) {
    const { primaryColor } = useTenantContext()

    const router = useRouter()
    const ctx = useAuth()
    const { user_profile } = ctx
    const { translations } = useAppContext()
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)

    const items: TopBarItem[] = [
        {
            translation_key: 'booking_page',
            text: 'Booking Page',
            icon: 'feather-watch',
            route: '/book',
        },
        {
            translation_key: 'booking_page.classes',
            text: 'Classes',
            icon: 'feather-calendar',
            route: '/book/classes',
            selected: true,
        },
        {
            translation_key: 'booking_page.appointments',
            text: 'Appointments',
            icon: 'feather-briefcase',
            route: '/book/appointments',
            selected: true,
        },
        {
            translation_key: 'booking_page.memberships',
            text: 'Memberships',
            icon: 'feather-shopping-bag',
            route: '/book/memberships',
        },
        // {
        //     translation_key: 'profile_settings',
        //     text: 'Profile Settings',
        //     icon: 'feather-user',
        //     route: '/book/client/profile',
        // },
    ]

    const handleSelect = (item: TopBarItem) => {
        delete router?.query?.s
        delete router?.query?.classId
        delete router?.query?.serviceId
        router.replace({
            pathname: item.route,
            query: router.query,
        })
        // ctx.expandNav(false)
        // setIsExpanded(false)
        Cookies.set('topbar', 'expanded')
        // router.push(item.route || '/')
    }

    const CustomItem = (item: TopBarItem) => (
        <button
            onClick={() => handleSelect(item)}
            className={classNames(
                'p-2 flex items-center cursor-pointer text-white hover:text-secondary booking-menu',
                // item.selected ? 'text-primary' : 'text-gray-700',
                router.pathname === item.route
                    ? 'border-b border-gray-100 hover:border-secondary'
                    : ''
            )}
        >
            <span className={`k-icon text-lg ${item.icon}`} />
            <Translation
                content_key={item.translation_key ?? ''}
                render_as="span"
                className="ml-2"
            />
            {/* <span className="ml-2">{getTranslation(item.translation_key, translations)}</span> */}
        </button>
    )

    return (
        <header
            className="w-full shadow-md top-0 left-0 z-10 fixed h-18 z-99 booking-topheader"
            style={{ backgroundColor: primaryColor }}
        >
            <div
                className="w-full px-4 sm:px-6 lg:px-8 h-18 k-mt-15"
                style={{ backgroundColor: primaryColor }}
            >
                <div className="max-w-7xl flex justify-between items-center py-3">
                    {/* TopBar Items */}
                    <div className="hidden md:flex space-x-2">
                        {items.map((item) => (
                            <CustomItem key={item.text} {...item} />
                        ))}
                    </div>

                    {/* Mobile Menu Toggle */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="text-gray-600 focus:outline-none"
                        >
                            <span className="feather-menu text-2xl" />
                        </button>
                    </div>
                </div>

                {/* Mobile Menu Items */}
                {isMenuOpen && (
                    <div className="md:hidden">
                        <div className="px-2 pt-2 pb-3  sm:px-3">
                            {items.map((item) => (
                                <CustomItem key={item.text} {...item} />
                            ))}
                        </div>
                    </div>
                )}
            </div>
            {/* Content Area */}
            <div className="">{children}</div>{' '}
            {/* Adjust padding to account for smaller header */}
        </header>
    )
}

export default BookingPageTopBar
